import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import SaleFooter from '../SaleFooter/SaleFooter';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import ProviderManager from '../../../../provider/providerManager';
import { getRecaptchaToken } from '../../../../utilities/recaptcha/recaptcha';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {
  goToPage,
  reportAnalytics,
  setIsSubmit,
  setIsValid,
  setPersonalInfo,
  setIsCustomerExposureSuccess,
  setError,
} from '../saleBlockSlice';
import PersonalInfo from '../PersonalInfo/PersonalInfo';

const PersonalInfoPage = (props) => {
  let saleType = props.saleType;
  let flowType = props.flowType;
  const [isPageRenderFromBack, setIsPageRenderFromBack] = useState(false);

  useEffect(() => {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    switch (saleType) {
      case 'tv':
        props.reportAnalytics({ eventCategory: 'tv_newsale_process', eventAction: 'visibility_22', eventLabel: eventLabel });
        break;
      case 'app':
        props.reportAnalytics({ eventCategory: 'app_newsale_process', eventAction: 'visibility_30', eventLabel: eventLabel });
        break;
      case 'cellular':
        props.reportAnalytics({ eventCategory: 'cellular_newsale_process', eventAction: 'visibility_25', eventLabel: 'screen_15' });
        break;
      case 'internet':
        props.reportAnalytics({ eventCategory: 'fiber_newsale_process', eventAction: 'visibility_18', eventLabel: eventLabel });
        break;
    }
  }, []);

  useExtendedEffect((runSideEffects) => {
    setIsPageRenderFromBack(!runSideEffects());
    console.info(`setIsPageRenderFromBack(!runSideEffects()): ${!runSideEffects()}`);
  }, []);

  //page params
  let isDisplayFooter = true;
  let btnText = 'המשך';
  let currentPageFunction = handlePersonalInfoPageContinue;
  let totalPrice = null;
  let priceText = 'לחודש';
  let formid = 'sale';

  //page params
  let title = 'היי, נעים להכיר :)';
  let subTitle = 'נשמח לכמה פרטים ונוכל להמשיך';
  if (saleType == 'internet') {
    title = 'מעולה, הכל מוכן';
    subTitle = 'בעוד כמה צעדים נשלים את ההזמנה';
    btnText = 'מתקדמים';
  } else if (saleType == 'tv') {
    title = `כמה פרטים ונעבור לסיכום הזמנה`;
    subTitle = '';
  } else if (saleType == 'cellular') {
    title = `היי, נעים להכיר :)`;
    subTitle = 'נשמח לכמה פרטים ונוכל להמשיך';
  }

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
      <h1 className='sale-title-big'>{title}</h1>
      <h2 className='sale-title-small'>{subTitle}</h2>
    </div>
  );

  let currentPageView = (
    <PersonalInfo
      onValid={handlePersonalInfoValidate}
      onSubmit={props.isSubmit}
      // customerId={identity}
      saletype={saleType}
    // isDisableIdentity={isPageRenderFromBack}
    />
  );

  function handlePersonalInfoPageContinue() {
    props.setIsSubmit({ isSubmit: true });
  }

  function handlePersonalInfoValidate(valid) {
    props.setIsSubmit({ isSubmit: false });
    if (valid) {
      handlePersonalInfoPageContinueAfterValid();
    }
    props.setIsSubmit({ isSubmit: false });
  }

  async function handlePersonalInfoPageContinueAfterValid() {
    const personalInfo = {
      firstName: props._personalInfo.form.firstName,
      lastName: props._personalInfo.form.lastName,
      id: props.otpIdentity,
      email: props._personalInfo.form.email,
      isReceivingAd: props._personalInfo.isReceivingAd,
      isReceivingBill: props._personalInfo.isReceivingBill,
    };

    props.setPersonalInfo({ personalInfo: personalInfo });

    let eventLabel = props.productsInfo.selectedProducts[0]?.name;

    switch (saleType) {
      case 'tv':
        props.reportAnalytics({ eventCategory: 'tv_newsale_process', eventAction: 'click_32', eventLabel: eventLabel });
        break;
      case 'app':
        props.reportAnalytics({ eventCategory: 'app_newsale_process', eventAction: 'click_42', eventLabel: eventLabel });
        break;
      case 'cellular':
        eventLabel = 'isReceivingAd = ' + props._personalInfo.isReceivingAd + ', isReceivingBill = ' + props._personalInfo.isReceivingBill;
        props.reportAnalytics({ eventCategory: 'cellular_newsale_process', eventAction: 'click_48', eventLabel: eventLabel });
        break;
      case 'internet':
        props.reportAnalytics({ eventCategory: 'fiber_newsale_process', eventAction: 'click_24', eventLabel: eventLabel });
        break;
    }

    const isValidIdNumber = await checkIdNumber(personalInfo.id);
    if (!isValidIdNumber) {
      props.setError({ isDisplay: true, id: 3, isOpenWorkOrder: true });
      return;
    }

    let productType = '';
    switch (saleType) {
      case 'tv':
      case 'app':
        productType = 'TV';
        break;
      case 'cellular':
        productType = 'CELLULAR';
        break;
      case 'internet':
        productType = 'INTERNET';
        break;
    }
    let productCount = 0;
    let productAmount = 0;
    if (saleType == 'cellular') {
      productCount = props.productsInfo.selectedProducts.length;
      props.productsInfo.selectedProducts.map((product, key) => {
        productAmount = parseFloat((productAmount + product.additionalPrice).toFixed(2));
      });
    }

    const isCustomerExposureSuccess = await getCustomerExposure(
      personalInfo.id,
      personalInfo.firstName,
      personalInfo.lastName,
      productType,
      productCount,
      productAmount,
      flowType,
      props.otpPhone
    );
    props.setIsCustomerExposureSuccess(isCustomerExposureSuccess);

    if (props.saleType == 'cellular') {
      let storage = window.localStorage || window.sessionStorage;
      let reservePhoneNumbers = JSON.parse(storage.getItem('reservePhoneNumbers')) || [];

      const listPhoneNumbers = props.productsInfo.selectedProducts
        .filter((x) => !reservePhoneNumbers.includes(x.newPhone))
        .map((x) => x.newPhone);
      if (listPhoneNumbers && listPhoneNumbers.length > 0) {
        const isSuccess = await reservePhoneNumber(personalInfo.id, listPhoneNumbers);
        if (isSuccess) {
          reservePhoneNumbers.push(...listPhoneNumbers);
          storage.setItem('reservePhoneNumbers', JSON.stringify(reservePhoneNumbers));
        } else {
          props.setError({ isDisplay: true, id: 34, isOpenWorkOrder: true });
          return;
        }
      }
    }

    switch (saleType) {
      case 'tv':
        props.goToPage({ page: 'summaryPage', percent: 72 });
        break;
      case 'app':
        props.goToPage({ page: 'summaryPage', percent: 70 });
        break;
      case 'cellular':
        props.goToPage({ page: 'summaryPage', percent: 80 });
        break;
      case 'internet':
        if (props.configuration.isDisplaySuperWifi) {
          props.goToPage({ page: 'meshUpgradePage', percent: 70 });
        } else {
          props.goToPage({ page: 'summaryPage', percent: 80 });
        }
        break;
    }
  }

  //881
  async function checkIdNumber(idNumber) {
    const captchaToken = await getRecaptchaToken('checkIdNumber');
    if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
      return;
    }

    console.info('checkIdNumber:', 'idNumber = ' + idNumber + ' captchaToken = ' + captchaToken);
    props.showAppLoader();
    try {
      const result = await ProviderManager.getProviderData('CheckIdNumber', [idNumber, captchaToken]);
      console.info('checkIdNumber', result);
      const isValidIdNumber = result && result.Body && result.Body.isSuccess;
      return isValidIdNumber;
    } catch (error) {
      console.info('checkIdNumber', error);
      return false;
    } finally {
      props.hideAppLoader();
    }
  }

  //1419
  async function emailIsExist(email) {
    props.showAppLoader();
    try {
      const result = await ProviderManager.getProviderData('emailIsExist', [email]);
      console.info('emailIsExist', result);
      const isAvailableEmail = result && result.Body && result.Body.isSuccess;
      return isAvailableEmail;
    } catch (error) {
      console.info('emailIsExist', error);
      return false;
    } finally {
      props.hideAppLoader();
    }
  }

  //667
  async function getCustomerExposure(id, firstName, lastName, productType, productCount, productAmount, flowType, otpPhone) {
    const captchaToken = await getRecaptchaToken('getCustomerExposure');
    if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
      return;
    }

    props.showAppLoader();
    try {
      const result = await ProviderManager.getProviderData('CustomerExposure', [
        id,
        firstName,
        lastName,
        productType,
        productCount,
        productAmount,
        captchaToken,
        flowType,
        otpPhone,
      ]);
      console.info('getCustomerExposure', result);
      const isSuccess = result.Body.returnCode == '00' && result.Body.nonSeparDepos == '0';
      return isSuccess;
    } catch (error) {
      console.info('getCustomerExposure', error);
      return false;
    } finally {
      props.hideAppLoader();
    }
  }

  //024
  async function reservePhoneNumber(idNumber, listPhoneNumbers) {
    props.showAppLoader();
    try {
      const reservePhoneNumber = {
        IdNumber: idNumber,
        ListPhoneNumbers: listPhoneNumbers,
      };
      const result = await ProviderManager.getProviderData('reservePhoneNumber', reservePhoneNumber);
      const isSuccess = result && result.Body && result.Body.isSuccess;
      return isSuccess;
    } catch (error) {
      return false;
    } finally {
      props.hideAppLoader();
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    configuration: state.saleBlock.epiServer.configuration,
    totalPrice: state.saleBlock.totalPrice,
    isSubmit: state.saleBlock.isSubmit,
    isValid: state.saleBlock.isValid,
    productsInfo: state.saleBlock.productsInfo,
    otpPhone: state.saleBlock.otpPhone,
    otpIdentity: state.saleBlock.otpIdentity,

    //other states
    _personalInfo: state.PersonalInfo,
    _authentication: state.authentication,
    _isStateReset: state.stateHistory.isStateReset,
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  setIsSubmit,
  setIsValid,
  setPersonalInfo,
  setIsCustomerExposureSuccess,
  setError,

  //loader
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfoPage);
